import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csintro(){

    const [padding, setWindowpadding] = useState(0);
    const [width, setWindowWidth] = useState(0);
    useEffect(() => {
      updateDimensions()
  
      window.addEventListener('resize', updateDimensions)
      return () => window.removeEventListener('resize', updateDimensions)
    }, [])
  
    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width < 998) {
        setWindowpadding(2.5)
      } else {
        setWindowpadding(14)
      }
    }
  
    
    const right = {
      padding: '0 0 0 '+padding+'rem',
    };
return(
      <div>
      <Sides/>
      
      <Helmet>
 
 <title>Learn Free PHP Introduction Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php if else if tutorial for beginners.if else if in Php is used for making a decision. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,introduction to php language,introduction to php,php introduction,introduction about php" />
 <link rel="canonical" href="https://www.codeexampler.com/php-introduction" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php Introduction</h1>
    <div className="first">
        <a href="/php-history"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        
        </div>
<p className="mt-4 para ">
1, Php is a server-side language. The PHP code is the same as JavaScript code.<br/>
2, The main advantage of PHP is giving you good monitoring over what Shows in the browser, like HTML code on a web page.<br/> 
3, The primary use of PHP uses to control dynamic content, maintain the database easily.<br/>
4, PHP is used to create large websites like e-commerce websites.<br/>
5, Php is used to handle forms like: data save if you can send data by email and fetch data by the user.<br/>
6, If you change any property inside the database by the use of PHP.<br/>
7, Could use PHP to build simple, dynamic web applications.</p>
  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/php-history"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        
        </div>
        </div>
    </div>
)

}
export default Csintro;